import type {StudyArtifactAttentionTarget, StudyFindingsPostResult, StudyFindingsView} from '@digital-twins/shared-types'
import httpClient from '@/lib/api/http-client'

export function sameStudyArtifactTarget(left: StudyArtifactAttentionTarget, right: StudyArtifactAttentionTarget): boolean {
  return left.threadToken === right.threadToken && left.originMessageToken === right.originMessageToken &&
    left.studyToken === right.studyToken && left.artifactToken === right.artifactToken && left.artifactRevision === right.artifactRevision
}
function findingsPath(thread: string, study: string) {
  return `/knowledge/threads/${encodeURIComponent(thread)}/studies/${encodeURIComponent(study)}/findings`
}
export const studyFindingsApi = {
  async read(thread: string, study: string, revision?: number) {
    return (await httpClient.get<StudyFindingsView>(`${findingsPath(thread, study)}${revision === undefined ? '' : `/${revision}`}`)).data
  },
  async post(target: StudyArtifactAttentionTarget) {
    return (await httpClient.post<StudyFindingsPostResult>(`${findingsPath(target.threadToken, target.studyToken)}/${target.artifactRevision}/post`)).data
  },
}
